import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["inputRef", "placeholder", "onKeyDown", "maxRows", "aria-describedby"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import Textarea from 'react-textarea-autosize';
import { KEY } from 'utils/ui/constants';
import { textInputStyle, textInputProps } from 'components/TextInput';
import { useFormFieldContext } from 'components/FormField';
import { jsx as _jsx } from "react/jsx-runtime";
var shouldForwardProp = function shouldForwardProp(prop) {
  return !textInputProps.includes(prop);
};
export var StyledTextarea = styled(Textarea).withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "TextArea__StyledTextarea",
  componentId: "sc-ecivc-0"
})(["", " min-height:41px;"], textInputStyle);
var TextArea = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var inputRef = _ref.inputRef,
    placeholder = _ref.placeholder,
    onKeyDown = _ref.onKeyDown,
    maxRows = _ref.maxRows,
    ariaDescribedBy = _ref['aria-describedby'],
    otherProps = _objectWithoutProperties(_ref, _excluded);
  function handleTextareaKeyDown(e) {
    var target = e.target;
    if (e.key === KEY.ENTER && e.metaKey) {
      var _target$form;
      target === null || target === void 0 || (_target$form = target.form) === null || _target$form === void 0 || _target$form.requestSubmit();
    }
    onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
  }
  var _useFormFieldContext = useFormFieldContext({
      id: otherProps.id,
      required: otherProps.required,
      descriptionIds: ariaDescribedBy
    }),
    id = _useFormFieldContext.id,
    required = _useFormFieldContext.required,
    horizontal = _useFormFieldContext.horizontal,
    descriptionIds = _useFormFieldContext.descriptionIds;
  return /*#__PURE__*/_jsx(StyledTextarea, _objectSpread(_objectSpread({}, otherProps), {}, {
    ref: ref || inputRef,
    id: id,
    required: required,
    "aria-describedby": descriptionIds
    // Safari has a [bug](https://bugs.webkit.org/show_bug.cgi?id=142968) where
    // empty input fields do not align correctly with baseline alignment.
    // Adding a "one space" placeholder fixes the issue.
    ,
    placeholder: horizontal ? placeholder || ' ' : placeholder,
    onKeyDown: handleTextareaKeyDown,
    maxRows: maxRows
  }));
});
TextArea.displayName = 'TextArea';
export default TextArea;